var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 76,
    viewBox: "0 0 58 76",
    width: 58,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    transform: "translate(.5 .308436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.5 34.75 47.5-28.75v69l-57-34.5v-5.75z",
    fill: "#1d2574"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.5 6 34.5 57h-69z",
    fill: "#2b3594",
    transform: "matrix(0 -1 1 0 -6 63)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 17.1915644 21.5 35h-43z",
    fill: "#1d2574",
    transform: "matrix(0 -1 1 0 -2.691564 66.691564)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftButton);
export default __webpack_public_path__ + "static/media/left-button.0be878db05aa16e37f5c600a7ee2c3f9.svg";
export { ForwardRef as ReactComponent };